export default __webpack_public_path__ + "assets/hg_pro_logo.b89590ee.png";